import Vue from 'vue';
import {MLInstaller, MLCreate, MLanguage} from 'vue-multilanguage';

import itData from './assets/content/data-it.json';
import ukData from './assets/content/data-uk.json';
import usData from './assets/content/data-us.json';
import esData from './assets/content/data-es.json';
import frData from './assets/content/data-fr.json';
import ptData from './assets/content/data-pt.json';
import brData from './assets/content/data-br.json';
import deData from './assets/content/data-de.json';
import nlData from './assets/content/data-nl.json';
import plData from './assets/content/data-pl.json';

import itContent from './assets/content/content-it.json';
import ukContent from './assets/content/content-uk.json';
import usContent from './assets/content/content-us.json';
import esContent from './assets/content/content-es.json';
import frContent from './assets/content/content-fr.json';
import ptContent from './assets/content/content-pt.json';
import brContent from './assets/content/content-br.json';
import deContent from './assets/content/content-de.json';
import nlContent from './assets/content/content-nl.json';
import plContent from './assets/content/content-pl.json';

const it = {data: itData, content: itContent};
const uk = {data: ukData, content: ukContent};
const us = {data: usData, content: usContent};
const es = {data: esData, content: esContent};
const fr = {data: frData, content: frContent};
const pt = {data: ptData, content: ptContent};
const br = {data: brData, content: brContent};
const de = {data: deData, content: deContent};
const nl = {data: nlData, content: nlContent};
const pl = {data: plData, content: plContent};

Vue.use (MLInstaller);

export default new MLCreate ({
  initial: 'it',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage ('it').create (it),
    new MLanguage ('uk').create (uk),
    new MLanguage ('us').create (us),
    new MLanguage ('es').create (es),
    new MLanguage ('fr').create (fr),
    new MLanguage ('pt').create (pt),
    new MLanguage ('br').create (br),
    new MLanguage ('de').create (de),
    new MLanguage ('nl').create (nl),
    new MLanguage ('pl').create (pl),
  ],
});
